(ns minorodata.analytics-models.domain
  "Reads over an analytics model, independent of how it is rendered — what
   documentation a registry model publishes, and how its `model-params` are keyed.

   Split out of `minorodata.components.analytics-models.docs` so these stay
   testable on node: the component ns renders `description-long` through
   react-markdown, whose remark-* packages are ESM-only and blow up on node's
   `require`."
  (:require [clojure.string :as str]))


(defn mapping-key
  "Kebab-case a `model-params` placeholder for lookup, mirroring kioku's
   `string-kebab-transform` (`kioku.app.interceptors`)."
  [placeholder]
  (when placeholder
    (->> (str/split (name placeholder) #"_")
         (map str/lower-case)
         (str/join "-")
         keyword)))


(defn params
  "The model's parameter blocks. Blocks without a `:name` (subtitles and other
   decoration) aren't parameters."
  [model]
  (filter :name (:analytics-model-registry/custom-ui-blocks model)))


(defn documented?
  "True when a model publishes anything worth opening the reference for — mirrors
   what the component ns's `model-docs` actually renders, so the dialog is never
   empty."
  [model]
  (let [{:keys [input-tables output-tables]} (:analytics-model-registry/table-definitions model)]
    (boolean (or (not (str/blank? (:analytics-model-registry/description-long model)))
                 (not (str/blank? (:analytics-model-registry/description-brief model)))
                 (seq (params model))
                 (seq input-tables)
                 (seq output-tables)))))
